import { FC, useState } from "react";
import { Assurance } from "../../lib/interfaces/assurance.interface";
import { TableCell, TableRow } from "../ui/table";
import { formatDate } from "../../lib/helpers/date_helpers";
import { Button } from "../ui/button";
import { Download } from "lucide-react";
import axiosClient from "../../lib/axiosClient";
import saveAs from "file-saver";
import { toast } from "sonner";

interface Props {
  assurance: Assurance;
}

const AttestationAssuranceRowItem: FC<Props> = ({ assurance: assu }) => {
  const [loadingAttestation, setLoadingAttestation] = useState(false);
  const facturesImpayees = assu.factures.filter((fac) => fac.payee === false);

  /* Ouvre l'attestation dans nouvelle fenetre */
  const telechargerAttestation = async () => {
    try {
      setLoadingAttestation(true);
      const { data } = await axiosClient.get(
        `/assurances/${assu.id}/attestation-file`,
        { responseType: "arraybuffer" }
      );
      const blob = new Blob([data], {
        type: "application/pdf",
      });
      saveAs(blob, "attestation-assurance.pdf");
    } catch (error) {
      toast.error("Une erreur s'est produite.");
    }
    setLoadingAttestation(false);
  };

  return (
    <TableRow>
      <TableCell className="font-medium">
        {assu.typeAssurance.description}
      </TableCell>
      <TableCell>
        Du {formatDate(assu.dateDebut)} au {formatDate(assu.dateFin)}
      </TableCell>
      <TableCell>{assu.ruches}</TableCell>
      <TableCell className="text-right">
        {facturesImpayees.length === 0 ? (
          <Button
            onClick={() => telechargerAttestation()}
            loading={loadingAttestation}
            icon={<Download className="w-4 h-4" />}
          />
        ) : (
          <div className="p-1 bg-orange-100 rounded-md text-center">
            En attente de paiement
          </div>
        )}
      </TableCell>
    </TableRow>
  );
};

export default AttestationAssuranceRowItem;
